import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../features/auth/authSlice";
import { useLoginMutation } from "../../features/auth/authApiSlice";
import { Row, Col, Form, FormGroup, Input, Button } from "reactstrap";
import "./LoginPage.css";
import image from "../../assets/images/login.svg";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";
import toast, { Toaster } from "react-hot-toast";

const LoginPage = () => {
  const emailRef = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const [login, { isLoading }] = useLoginMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    emailRef.current.focus();
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const userData = await login({ email, password }).unwrap();
      dispatch(setCredentials({ ...userData }));
      setEmail("");
      setPassword("");
      navigate("/home");
    } catch (err) {
      toast.error(err?.data?.message || "Login failed...!");
    }
  };

  const content = (
    <div className="main">
      <Toaster position="top-right" reverseOrder={false} />
      {isLoading && <LoadingSpinner />}
      <div className="container zoom-out">
        <Row className="justify-content-center align-items-center shadow-lg bg-body login-container overflow-hidden">
          <Col
            md={6}
            className="d-flex justify-content-center p-0 img-container"
          >
            <div className="bg-image">
              <img src={image} alt="" className="img-fluid" />
            </div>
          </Col>
          <Col md={6} className="login-content">
            <div>
              <h1>Welcome!</h1>
              <h4>Limelight Order Tracker</h4>
            </div>
            <Form className="login-form" onSubmit={handleFormSubmit}>
              <FormGroup className="mb-5">
                <Input
                  type="email"
                  name="email"
                  id="email"
                  ref={emailRef}
                  placeholder="Email"
                  className="form-control custom-field"
                  value={email}
                  onChange={handleEmailChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Password"
                  className="form-control custom-field"
                  value={password}
                  onChange={handlePasswordChange}
                  required
                />
              </FormGroup>
              {/*<FormGroup className="d-flex justify-content-end align-items-center">*/}
              {/*  <a href="/" className="forgot-password">*/}
              {/*    Forgot Password!*/}
              {/*  </a>*/}
              {/*</FormGroup>*/}
              <div className="text-center my-5">
                <Button
                  color="primary"
                  className="submit-button w-75 btn-gradient"
                >
                  Login
                </Button>
              </div>
            </Form>
           
            <h6 className="text-center mt-5">V1.9</h6>
          </Col>
        </Row>
      </div>
    </div>
  );

  return content;
};

export default LoginPage;
